/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IMODALITIES {
  Treadmill = 'treadmill',
  Bike = 'bike',
  Rower = 'rower',
  Elliptical = 'elliptical',
  Yoga = 'yoga',
  Strength = 'strength',
  Mind = 'mind',
  Any = 'any',
}
